import {ChangeDetectionStrategy, Component, input} from '@angular/core'
import {faInfoCircle} from '@fortawesome/pro-duotone-svg-icons/faInfoCircle'

@Component({
  selector: 'cft-price-range-info',
  templateUrl: './price-range-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: block; }'],
})
export class PriceRangeInfoComponent {
  infoText = input.required<string>()
  hint = input<string>()

  protected readonly infoIcon = faInfoCircle
}
